<div class="modal-container" [class.redesign]="isRedesign">
  @if (isRedesign) {
  <button type="button" class="close-button pull-right" (click)="close()" aria-label="Close" title="Close">
    <i class="fa-sharp fa-light fa-xmark" aria-hidden="true"></i>
  </button>
  <div class="modal-head">
    <h2>Welcome to companybox</h2>
    <p>Log in or create an account to save your designs.</p>
  </div>
  }
  <div class="navigation-tabs">
    <button (click)="activeLoginModalTab = 'login'" class="tab" [ngClass]="getActiveTab('login')">LOGIN</button>
    <button
      (click)="activeLoginModalTab = 'signup'; forgotPasswordActive = false"
      class="tab"
      [ngClass]="getActiveTab('signup')"
    >
      SIGN UP
    </button>
  </div>
  @if (activeLoginModalTab === 'login' && !forgotPasswordActive) {
  <div class="modal-body">
    @if(loginError) {
      <div class="form-error">
        <div class="alert alert-danger">
          <div id="loginError"><span class="fas fa-ban text-danger"></span> {{loginError}}</div>
        </div>
      </div>
    }
    <div class="container-fluid">
      <form class="login-container" [class.forgot-password-active]="forgotPasswordActive">
        <mat-label for="email">Email</mat-label>
        <input matInput id="loginEmail" name="email"
               [(ngModel)]="loginData.username" [class.is-invalid]="loginError"
        />
        @if(loginError) {
          <div class="invalid-feedback d-block text-start"></div>
        }
        <mat-label for="password">Password</mat-label>
        <input
          matInput id="loginPassword" name="password" type="password"
          [(ngModel)]="loginData.password" (keyup.enter)="login()" [class.is-invalid]="loginError"
        />
        @if(loginError) {
          <div class="invalid-feedback d-block text-start"></div>
        }
      </form>
    </div>
    <div class="form-actions form-actions--login">
      <a (click)="forgotPasswordActive = true">Forgot your password?</a>
      <button id="loginBtn" type="button" class="white-submit login" (click)="login()" [class.disabled]="loginPending">
        @if (loginPending) {
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only"></span>
        </div>
        }
        LOGIN</button>
    </div>
  </div>
  } @if (activeLoginModalTab === 'login' && forgotPasswordActive) {
  <div class="modal-body">
    <div class="container-fluid">
      <form class="recovery-container slide-in-container" [class.forgot-password-active]="forgotPasswordActive">
        <div class="mat-label-compressable" for="recover-email">Enter the email associated with your account</div>
        <input matInput name="recover-email" [(ngModel)]="recoveryEmail" />
        <a (click)="forgotPasswordActive = false">Cancel</a>
      </form>
    </div>
    <div class="form-actions">
      <button type="button" class="white-submit login" (click)="send()" [class.disabled]="sendPending">
        @if (sendPending) {
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only"></span>
        </div>
        }
        SEND</button>
    </div>
  </div>
  } @if (activeLoginModalTab === 'Noaccount') {
  <div class="modal-body">
    @if (!passwordInfo) {
    <div class="info-container1">
      <div class="column-header1">Not in the mood to create an account? Take it for a test drive.</div>
      <ul>
        <li>Get access to our test builder</li>
        <li>Will <i>not</i> be able to save work</li>
        <li>You cannot add to cart or pay for your test design</li>
        <li>Get access to our test builder</li>
      </ul>
    </div>
    }
  </div>
  } @if (activeLoginModalTab === 'signup') {
  <div class="modal-body text-left align-items-center">
    <div class="container-fluid requirements signup-container">
      <div class="form-container mw-50">
        @if(signupError) {
          <div class="alert alert-danger">
            <div id="signupError"><span class="fas fa-ban text-danger"></span> {{signupError}}</div>
          </div>
        }
        <form class="login-container">
          <mat-label for="email">Email</mat-label>
          <input name="email" [(ngModel)]="registerData.username" matInput id="email" [class.is-invalid]="signupFieldErrors['username']" />
          @if (signupFieldErrors['username']) {
            <div class="invalid-feedback d-block text-start">{{signupFieldErrors['username']}}</div>
          }
          <mat-label for="first-name">First Name</mat-label>
          <input matInput autocomplete="first-name" id="first-name" name="first-name"
            [(ngModel)]="registerData.firstName" [class.is-invalid]="signupFieldErrors['firstName']"
          />
          @if (signupFieldErrors['firstName']) {
            <div class="invalid-feedback d-block text-start">{{signupFieldErrors['firstName']}}</div>
          }
          <mat-label for="last-name">Last Name</mat-label>
          <input matInput autocomplete="last-name" id="last-name" name="last-name"
            [(ngModel)]="registerData.lastName" [class.is-invalid]="signupFieldErrors['lastName']"
          />
          @if (signupFieldErrors['lastName']) {
            <div class="invalid-feedback d-block text-start">{{signupFieldErrors['lastName']}}</div>
          }
          <mat-label for="password">Password</mat-label>
          <input
            matInput id="password" name="password" type="password"
            (ngModelChange)="validatePassword($event, registerData.passwordConfirmation)" [(ngModel)]="registerData.password"
            [class.is-invalid]="signupFieldErrors['password']"
          />
          @if (signupFieldErrors['password']) {
            <div class="invalid-feedback d-block text-start">{{signupFieldErrors['password']}}</div>
          }
          <mat-label for="confirm-password">Confirm Password</mat-label>
          <input
            matInput id="confirm-password" name="confirm-password" type="password"
            (ngModelChange)="validatePassword(registerData.password, $event)" [(ngModel)]="registerData.passwordConfirmation"
            [class.is-invalid]="signupFieldErrors['passwordConfirmation']"
          />
          @if (signupFieldErrors['passwordConfirmation']) {
            <div class="invalid-feedback d-block text-start">{{signupFieldErrors['passwordConfirmation']}}</div>
          }
        </form>
        <div class="form-actions">
          <button type="button" class="white-submit signup" (click)="createUser()" [class.disabled]="signupPending">
            @if (signupPending) {
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only"></span>
            </div>
            }
            SIGN UP</button>
        </div>
      </div>
      <div class="container mw-25">
        <div class="info-container web-only">
          <div class="column-header">Create an account for access to:</div>
          <ul>
            <li>Unlimited design storage</li>
            <li>Purchase order history</li>
            <li>One-click purchasing</li>
            <li>Faster customer support</li>
          </ul>
        </div>
        <div class="info-container requirements web-tab-only" id="password-requirements">
          <div class="column-header">Password requirements:</div>
          <ul>
            <li id="length" class="validation" [ngClass]="{ valid: hasMinimumChars, invalid: passwordTouched && !hasMinimumChars }">
              @if (passwordTouched && hasMinimumChars) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !hasMinimumChars) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              Be at least <strong>8 characters</strong>
            </li>
            <li id="lowercase" class="validation" [ngClass]="{ valid: hasLowerLetter, invalid: passwordTouched && !hasLowerLetter }">
              @if (passwordTouched && hasLowerLetter) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !hasLowerLetter) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              At least <strong>one letter</strong>
            </li>
            <li id="uppercase" class="validation" [ngClass]="{ valid: hasCapitalLetter, invalid: passwordTouched && !hasCapitalLetter }">
              @if (passwordTouched && hasCapitalLetter) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !hasCapitalLetter) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              At least <strong>one capital letter</strong>
            </li>
            <li id="number" class="validation" [ngClass]="{ valid: hasNumber, invalid: passwordTouched && !hasNumber }">
              @if (passwordTouched && hasNumber) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !hasNumber) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              At least <strong>one number</strong>
            </li>
            <li id="special" class="validation" [ngClass]="{ valid: hasSpecialChar, invalid: passwordTouched && !hasSpecialChar }">
              @if (passwordTouched && hasSpecialChar) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !hasSpecialChar) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              At least <strong>one special character (%^&$#)</strong>
            </li>
            <li id="password-match" class="validation" [ngClass]="{ valid: passwordsMatch, invalid: passwordTouched && !passwordsMatch }">
              @if (passwordTouched && passwordsMatch) {
              <span><span class="fas fa-check text-success"></span></span>
              } @if (passwordTouched && !passwordsMatch) {
              <span><span class="fas fa-ban text-danger"></span></span>
              }
              Passwords match
            </li>
          </ul>
        </div>
      </div>
      <!-- NOTE: there are two password requirement containers; any changes to one should be made to the other -->
    </div>
    <div class="info-container requirements mobile-only">
      <div class="column-header">Password requirements:</div>
      <ul>
        <li id="length" class="validation" [ngClass]="{ valid: hasMinimumChars, invalid: passwordTouched && !hasMinimumChars }">
          @if (passwordTouched && hasMinimumChars) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !hasMinimumChars) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } Be at least <strong>8 characters</strong>
        </li>
        <li id="lowercase" class="validation" [ngClass]="{ valid: hasLowerLetter, invalid: passwordTouched && !hasLowerLetter }">
          @if (passwordTouched && hasLowerLetter) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !hasLowerLetter) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one letter</strong>
        </li>
        <li id="uppercase" class="validation" [ngClass]="{ valid: hasCapitalLetter, invalid: passwordTouched && !hasCapitalLetter }">
          @if (passwordTouched && hasCapitalLetter) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !hasCapitalLetter) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one capital letter</strong>
        </li>
        <li id="number" class="validation" [ngClass]="{ valid: hasNumber, invalid: passwordTouched && !hasNumber }">
          @if (passwordTouched && hasNumber) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !hasNumber) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one number</strong>
        </li>
        <li id="special" class="validation" [ngClass]="{ valid: hasSpecialChar, invalid: passwordTouched && !hasSpecialChar }">
          @if (passwordTouched && hasSpecialChar) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !hasSpecialChar) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one special character (%^&$#)</strong>
        </li>
        <li id="password-match" class="validation" [ngClass]="{ valid: passwordsMatch, invalid: passwordTouched && !passwordsMatch }">
          @if (passwordTouched && passwordsMatch) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (passwordTouched && !passwordsMatch) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } Passwords match
        </li>
      </ul>
    </div>
  </div>
  }
</div>
